import $ from "jquery";

let timeout = null;
$(".js-autocomplete-input").on("input", (e) => {
  const searchInput = $(e.currentTarget);
  const id = searchInput.data("id");
  const suggestionsList = $("#autocomplete-" + id);

  clearTimeout(timeout);

  timeout = setTimeout(() => {
    getTypeaheadResults(
      searchInput.val(),
      searchInput.data("category"),
      suggestionsList,
    );
  }, 500);
});

const autocompleteForm = $(".js-autocomplete-input").parents("form");
const autocompleteSuggestions = autocompleteForm.find(
  ".js-autocomplete-suggestions",
);

autocompleteSuggestions.on("keydown", (e) => {
  const optionInFocus = autocompleteSuggestions.find("> li a:focus");
  const parentListItem = optionInFocus.parent();

  switch (e.which) {
    case 13: // Enter
      selectOption(optionInFocus);
      break;

    case 38: // Up
      parentListItem.prev().find(".autocomplete-option").focus();
      break;

    case 40: // Down
      parentListItem.next().find(".autocomplete-option").focus();
      break;

    default:
      return; // exit this handler for other keys
  }
  e.preventDefault();
});

$(".js-autocomplete-input").on("keydown", (e) => {
  if (e.which === 13) {
    // Enter key
    e.preventDefault();
    return;
  }
  if (e.which !== 40) {
    // Not the down key
    return;
  }
  autocompleteForm
    .find(".js-autocomplete-suggestions > li")
    .first()
    .find(".autocomplete-option")
    .focus();

  e.preventDefault(); // prevent the default action (scroll / move caret)
});

const selectOption = (option) => {
  const origId = option.parents("ul").attr("id");
  const id = origId.replace("autocomplete-", "");
  const input = $("#" + id);
  const info = $("#" + origId.replace("autocomplete-", "additional-info-"));

  input.val(option.data("value"));
  info.html(option.data("additional-value"));
  const e = new Event("change");
  input[0].dispatchEvent(e);
  $(".js-autocomplete-suggestions").removeClass("open");
};

$(document).on("click", ".autocomplete-option", (e) => {
  e.preventDefault();

  selectOption($(e.currentTarget));
});

$("html").click((e) => {
  if (!$(e.target).hasClass("autocomplete-option")) {
    const suggestions = $(".js-autocomplete-suggestions.open");
    if (suggestions.length <= 0) {
      return;
    }
    const id = suggestions.attr("id");
    const input = $("#" + id.replace("autocomplete-", ""));
    input.val("");
    const ev = new Event("change");
    input[0].dispatchEvent(ev);
    const info = $("#" + id.replace("autocomplete-input-", "additional-info-"));
    info.html("");
    $(".js-autocomplete-suggestions").removeClass("open");
  }
});

const getTypeaheadResults = (searchValue, category, suggestionsList) => {
  let url = "/umbraco/api/AutocompleteApi/Search";
  url = url + "?query=" + searchValue + "&category=" + category;
  $.ajax({
    cache: false,
    contentType: "application/json",
    type: "POST",
    url,
    success(result) {
      suggestionsList.addClass("open");
      suggestionsList.html("");
      if (result.length > 0) {
        let suggestion = "";

        $.each(result, (i, item) => {
          const additonalVariables = Object.getOwnPropertyNames(
            item.additionalProperties,
          )
            .filter((s) => {
              return (
                item.additionalProperties &&
                item.additionalProperties[s].length > 0
              );
            })
            .map((e) => {
              return `<div class='suggestion-info-item'><strong> ${e}: </strong> ${item.additionalProperties[e]}</div>`;
            })
            .join("");

          suggestion += `<li>
            <a class="autocomplete-option" href="#" data-value="${item.targetValue}" data-additional-value="${additonalVariables}">
             ${item.caption}
             </a> </li>`;
        });

        suggestionsList.html(suggestion);
      } else {
        suggestionsList.html(
          `<li class="autocomplete-suggestions__no-results">No options matching query</li>`,
        );
      }
    },
  });
};
